"use client";

import { Bookmark, Link2, Send, Share2 } from "lucide-react";
import { toast } from "sonner";

function shareUrl(): string {
  if (typeof window === "undefined") return "";
  return window.location.href;
}

async function copyLink() {
  try {
    await navigator.clipboard.writeText(shareUrl());
    toast.success("Link copied to clipboard");
  } catch {
    toast.error("Could not copy link");
  }
}

async function nativeShare(title: string) {
  const url = shareUrl();
  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch {
      /* user cancelled — fall through to copy */
    }
  }
  await copyLink();
}

function shareToX(title: string) {
  const url = shareUrl();
  const intent = `https://x.com/intent/tweet?text=${encodeURIComponent(
    title
  )}&url=${encodeURIComponent(url)}`;
  window.open(intent, "_blank", "noopener,noreferrer");
}

/** Desktop-only floating share rail, fixed to the left margin. */
export function ShareRail({ title }: { title: string }) {
  return (
    <div className="blog-rail" aria-label="Share">
      <button type="button" aria-label="Copy link" onClick={copyLink}>
        <Link2 />
      </button>
      <button type="button" aria-label="Share on X" onClick={() => shareToX(title)}>
        <Send />
      </button>
      <button
        type="button"
        aria-label="Bookmark"
        onClick={() => toast("Bookmark this page with ⌘/Ctrl + D")}
      >
        <Bookmark />
      </button>
    </div>
  );
}

/** Inline share actions shown in the byline row. */
export function BylineActions({ title }: { title: string }) {
  return (
    <div className="blog-byline-actions">
      <button
        type="button"
        className="blog-icon-btn"
        aria-label="Share"
        onClick={() => nativeShare(title)}
      >
        <Share2 />
      </button>
      <button
        type="button"
        className="blog-icon-btn"
        aria-label="Bookmark"
        onClick={() => toast("Bookmark this page with ⌘/Ctrl + D")}
      >
        <Bookmark />
      </button>
    </div>
  );
}
